import { render } from "./CatalogoProductos.vue?vue&type=template&id=6fd3fcae&scoped=true"
import script from "./CatalogoProductos.vue?vue&type=script&lang=js"
export * from "./CatalogoProductos.vue?vue&type=script&lang=js"

import "./CatalogoProductos.vue?vue&type=style&index=0&id=6fd3fcae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd3fcae"]])

export default __exports__